// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/alloys/partners/shopify/:app_group_id/bridges/:bridge_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { alloysPartnersShopifyAppGroupIdBridgesBridgeId } from "./constants";
import type { AlloysPartnersShopifyAppGroupIdBridgesBridgeIdResult } from "./types";
import { isAlloysPartnersShopifyAppGroupIdBridgesBridgeIdResult } from "./validators";

export type AlloysPartnersShopifyAppGroupIdBridgesBridgeIdQueryParams = {
  integration_id?: string;
};

export const getAlloysPartnersShopifyAppGroupIdBridgesBridgeId = reactQueryFetcherAdapter(
  alloysPartnersShopifyAppGroupIdBridgesBridgeId,
  (
    signal: AbortSignal,
    appGroupId: string,
    bridgeId: string,
    queryParams?: AlloysPartnersShopifyAppGroupIdBridgesBridgeIdQueryParams
  ): Promise<AlloysPartnersShopifyAppGroupIdBridgesBridgeIdResult> => {
    return fetch(
      `/alloys/partners/shopify/${appGroupId}/bridges/${bridgeId}`,
      "GET",
      queryParams ?? {},
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isAlloysPartnersShopifyAppGroupIdBridgesBridgeIdResult
);
